import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  title: {
    marginBottom: 8,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 16,
  },
  tooltip: {
    '&.apexcharts-tooltip': {
      background: '#f3f3f3',
      color: '#000',
    },
  },
}));
